<template>
    <div id="app" :class="'step-'+step">
        <div class="stepper d-print-none">
            <div>
                <button @click="step = 1" :class="{'active': step === 1}" class="btn">Step 01</button>
            </div>
            <div>
                <button @click="step = 2" :class="{'active': step === 2}" class="btn">Step 02</button>
            </div>
            <div>
                <button @click="step = 3" :class="{'active': step === 3}" class="btn">Step 03</button>
            </div>
            <div>
                <button @click="step = 4" :class="{'active': step === 4}" class="btn">Step 04</button>
            </div>
            <div>
                <button @click="step = 5" :class="{'active': step === 5}" class="btn">View and download</button>
            </div>
        </div>
        <v-stepper style="display:none" :linear="false" class="stepper" ref="stepper" :steps="steps" v-model="step"></v-stepper>
        <div v-if="step === 1" class="card-box">
            <h1 class="text-center text-uppercase">Let's get started</h1>
            <h5 class="text-center">Start your business plan</h5>
            <form class="m-t-20">
                <div class="col-md-12 m-0 p-0">
                    <div class="form-group">
                        <label>Business name <span class="text-danger">*</span></label>
                        <input type="text" placeholder="Apple Inc." class="form-control" v-model="company.name">
                    </div>
                    <div class="form-group">
                        <label>Revenue Goal $ <span class="text-danger">*</span></label>
                        <money class="form-control" :class="{'alert-danger': company.goal <= 0}" v-model="company.goal"
                               v-bind="money"></money>
                    </div>
                    <div class="form-group">
                        <label>Year over year growth expectation % <span class="text-danger">*</span></label>
                        <input type="text" placeholder="20" class="form-control" v-model="company.growth">
                    </div>
                    <div class="form-group">
                        <label>Email <span class="text-danger">*</span></label>
                        <input type="text" placeholder="cool@business.com" class="form-control" v-model="company.email">
                    </div>
                    <div class="form-group">
                        <label>Address</label>
                        <input type="text" placeholder="1533 US Highway 49, Magee, MS 39111" class="form-control"
                               v-model="company.address">
                    </div>
                    <div class="form-group">
                        <label>Phone</label>
                        <input type="text" placeholder="19658088617" class="form-control" v-model="company.phone">
                    </div>
                </div>
            </form>
        </div>
        <div v-if="step === 2" class="card-box" style="padding-top:20px;">
            <h2 class="text-uppercase text-center">TELL US ABOUT YOUR REVENUE DRIVERS</h2>
            <div class="row" style="margin-top:40px;">
                <div class="col-md-4">
                    <div class="form-group">
                        <strong>Revenue Goal $ <span class="text-danger">*</span></strong>
                        <money class="form-control" :class="{'alert-danger': company.goal <= 0}" v-model="company.goal"
                               v-bind="money"></money>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <strong>Expenses $ <span class="text-danger">*</span></strong>
                        <money class="form-control" :class="{'alert-danger': company.expenses <= 0}" v-model="company.expenses"
                               v-bind="money"></money>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <strong>Profit</strong>
                        <h6 style="margin-top:15px;"><span class="text-success">{{isNaN(company.goal - company.expenses) ? 0 : (company.goal - company.expenses) | money}}</span> or <span class="text-success">{{isNaN((100 - company.expenses / company.goal * 100)) ? 0 : parseInt(100 - company.expenses / company.goal * 100)}}%</span></h6>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-top:20px;margin-bottom: 10px;">
                <div class="col-8">
                    <strong>WHAT PRODUCTS OR SERVICES DO YOU OFFER</strong>
                </div>
                <div class="col-4 text-right">
                    <button @click="addType" type="button" class="btn btn-outline-success btn-sm">Add new</button>
                </div>
            </div>
            <div class="mobile">
                <div class="job-typer row"  :key="index" v-for="(type, index) in computedTypes">
                    <div class="col-6">
                        <label for="">Job type</label>
                        <input type="text" placeholder="Water damage" class="form-control" :class="{'alert-danger': !type.name || !type.name.length}" v-model="type.name">
                    </div>
                    <div class="col-6">
                        <label for="">Avg. job amount $</label>
                        <money class="form-control" v-model="type.amount" :class="{'alert-danger': type.amount <= 0}" v-bind="money"></money>
                    </div>
                    <div class="col-6">
                        <label for="">
                            Revenue
                            <strong class="m-2" style="margin-right:3px!important">$</strong><input type="radio" value="$" v-model="revenue_type">
                            <strong class="m-2" style="margin-right:3px!important">%</strong><input type="radio" value="%" v-model="revenue_type">
                        </label>
                        <money v-if="revenue_type === '$'" class="form-control" v-model="type.revenue"
                               v-bind="money"></money>
                        <money v-if="revenue_type === '%'" class="form-control"
                               :class="{'alert-danger': type.revenue > 100 || type.revenue < 0}"
                               v-model="type.revenue" v-bind="percentage"></money>
                        <div style="float:left;margin-top:3px;margin-left:10px;font-size: 90%;color:gray">
                            <i v-if="revenue_type === '%'">{{type.formattedRevenue}}</i>
                            <i v-if="revenue_type === '$'">{{type.calculatedPercantage}}%</i>
                        </div>
                    </div>
                    <div class="col-6">
                        <label for="">Conversion %</label>
                        <money  style="width: 75px;float:left;" class="form-control" v-model="type.conversion"
                                :class="{'alert-danger': type.conversion > 100 || type.conversion < 0}"
                                v-bind="percentage"></money>
                        <button @click="deleteType(index)" type="button" class="btn btn-danger btn-sm minus-btn" style="float:right"> x
                        </button>
                    </div>
                </div>
            </div>
            <div class="not-mobile">
                <table class="table table-bordered table-striped  table-sm" style="margin-top:15px;">
                    <thead>
                    <tr class="table-warning">
                        <th>Job type</th>
                        <th>Avg. job amount $</th>
                        <th>
                            Revenue
                            <strong class="m-2" style="margin-right:3px!important">$</strong><input type="radio" value="$"
                                                                                                    v-model="revenue_type">
                            <strong class="m-2" style="margin-right:3px!important">%</strong><input type="radio" value="%"
                                                                                                    v-model="revenue_type">
                        </th>
                        <th>Conversion %</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr :key="index" v-for="(type, index) in computedTypes">
                        <td><input type="text" placeholder="Water damage" class="form-control" :class="{'alert-danger': !type.name || !type.name.length}" v-model="type.name"></td>
                        <td>
                            <money style="width: 150px" class="form-control" v-model="type.amount" :class="{'alert-danger': type.amount <= 0}"
                                   v-bind="money"></money>
                        </td>
                        <td>
                            <div style="float:left">
                                <money style="width: 150px" v-if="revenue_type === '$'" class="form-control" v-model="type.revenue"
                                       v-bind="money"></money>
                                <money style="width: 150px" v-if="revenue_type === '%'" class="form-control"
                                       :class="{'alert-danger': type.revenue > 100 || type.revenue < 0}"
                                       v-model="type.revenue" v-bind="percentage"></money>
                            </div>
                            <div style="float:left;margin-top:7px;margin-left:10px;font-size: 90%;color:gray">
                                <i v-if="revenue_type === '%'">{{type.formattedRevenue}}</i>
                                <i v-if="revenue_type === '$'">{{type.calculatedPercantage}}%</i>
                            </div>
                        </td>
                        <td>
                            <money  style="width: 100px" class="form-control" v-model="type.conversion"
                                    :class="{'alert-danger': type.conversion > 100 || type.conversion < 0}"
                                    v-bind="percentage"></money>
                        </td>
                        <td>
                            <button @click="deleteType(index)" type="button" class="btn btn-danger btn-sm minus-btn"> x
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

        </div>
        <div v-if="step === 3" class="card-box" style="padding-top:20px;">
            <h2 class="text-center text-uppercase">LET’S FIGURE EXPENSE</h2>
            <div class="row" style="margin-top:40px;">
                <div class="col-md-4">
                    <div class="form-group">
                        <strong>Revenue Goal $ <span class="text-danger">*</span></strong>
                        <money class="form-control" :class="{'alert-danger': company.goal <= 0}" v-model="company.goal"
                               v-bind="money"></money>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <strong>Expenses $ <span class="text-danger">*</span></strong>
                        <money class="form-control" :class="{'alert-danger': company.expenses <= 0}" v-model="company.expenses"
                               v-bind="money"></money>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <strong>Profit</strong>
                        <h6 style="margin-top:15px;"><span class="text-success">{{isNaN(company.goal - company.expenses) ? 0 : (company.goal - company.expenses) | money}}</span> or <span class="text-success">{{isNaN((100 - company.expenses / company.goal * 100)) ? 0 : parseInt(100 - company.expenses / company.goal * 100)}}%</span></h6>
                    </div>
                </div>
            </div>


            <div class="row not-mobile" style="margin-top:20px;">
                <div class="col-md-10">
                    <h5>Great! Please fill in expenses</h5>
                </div>
                <div class="col-md-2 text-right">
                    <button @click="addExpense" type="button" class="btn btn-outline-success btn-sm">Add new</button>
                </div>
            </div>
            <div class="row mobile" style="margin-top:20px;">
                <div class="col-8">
                    <label>Great! Please fill in expenses</label>
                </div>
                <div class="col-4 text-right">
                    <button @click="addExpense" type="button" class="btn btn-outline-success btn-sm">Add new</button>
                </div>
            </div>
            <table class="table table-bordered table-striped  table-sm" style="margin-top:15px;">
                <thead>
                <tr class="table-warning">
                    <th>Target</th>
                    <th>
                        Amount
                        <strong class="m-2" style="margin-right:3px!important">$</strong>
                        <input type="radio" value="$" v-model="expense_type">
                        <strong class="m-2" style="margin-right:3px!important">%</strong>
                        <input type="radio" value="%" v-model="expense_type">
                    </th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr :key="index" v-for="(expense, index) in computedExpenses">
                    <td><input type="text" placeholder="Marketing" class="form-control"
                               :class="{'alert-danger': !expense.name || !expense.name.length}" v-model="expense.name"></td>
                    <td>
                        <div style="float:left">
                            <money v-if="expense_type === '$'" class="form-control" v-model="expense.amount"
                                   v-bind="money"></money>
                            <money v-if="expense_type === '%'" class="form-control"
                                   :class="{'alert-danger': expense.amount > 100 || type.amount < 0}"
                                   v-model="expense.amount" v-bind="percentage"></money>
                        </div>
                        <div style="float:left;margin-top:7px;margin-left:10px;font-size: 90%;color:gray">
                            <i v-if="expense_type === '%'">{{expense.formattedValue}}</i>
                            <i v-if="expense_type === '$'">{{expense.calculatedPercantage}}%</i>
                        </div>
                    </td>
                    <td>
                        <button @click="deleteExpense(index)" type="button" class="btn btn-danger btn-sm minus-btn"> x
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="step === 4" class="card-box">
            <h2 class="text-center text-uppercase">WHAT’S YOUR VISION?</h2>
            <div style="height:40px;"></div>
            <div class="form-group">
                <strong class="text-center text-uppercase">Mission & Vision</strong>
                <textarea class="form-control" v-model="questions.mission"></textarea>
            </div>
            <div class="form-group">
                <strong class="text-center text-uppercase">Who are my target customer </strong>
                <div class="row" style="margin-bottom:20px;" :key="index" v-for="(target, index) in questions.targets">
                    <div class="col-10">
                        <input class="form-control" type="text" v-model="target.name">
                    </div>
                    <div class="col-2 p-0">
                        <button v-if="index === questions.targets.length - 1" @click="questions.targets.push({name: ''})" class="btn btn-sm btn-success">+</button>
                        <button v-else @click="questions.targets.splice(index, 1)" class="btn btn-sm btn-danger">X</button>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <strong class="text-center text-uppercase">How are you going to generate leads?</strong>
                <textarea class="form-control" v-model="questions.generate_leads"></textarea>
            </div>
            <div class="form-group">
                <strong class="text-center text-uppercase">How many leads from each source?</strong>
                <textarea class="form-control" v-model="questions.leads_source"></textarea>
            </div>
            <div class="form-group">
                <strong class="text-center text-uppercase">Why will customer hire me?</strong>
                <textarea class="form-control" v-model="questions.hire"></textarea>
            </div>
        </div>
        <div id="preview" class="card-box" v-if="step === 5">
            <h1 class="text-center" style="text-transform: uppercase;font-size: 40px">business plan</h1>
            <div class="not-mobile">
                <div class="row headersh3">
                    <div class="col-6">
                        <h2 style="margin-bottom:7px;text-transform: uppercase;font-size: 20px">{{company.name}}</h2>
                        <p style="margin-bottom:7px;text-transform: initial;font-weight:normal">{{company.address}}</p>
                        <p style="margin-bottom:7px;">{{company.email}}</p>
                        <p style="margin-bottom:7px;">{{company.phone}}</p>
                    </div>
                    <div class="col-6">
                        <table class="table table-bordered">
                            <tbody>
                            <tr>
                                <td class="bg-warning" style="text-transform: capitalize">First Year Revenue Goals</td>
                                <td>{{company.goal | money}}</td>
                            </tr>
                            <tr>
                                <td class="bg-warning" style="text-transform: initial">Year over year growth expectation</td>
                                <td>{{company.growth}}%</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="mobile">
                <div class="row headersh3">
                    <div class="col-12">
                        <h2 style="margin-bottom:7px;text-transform: uppercase;font-size: 20px">{{company.name}}</h2>
                        <p style="margin-bottom:7px;text-transform: initial;font-weight:normal">{{company.address}}</p>
                        <p style="margin-bottom:7px;">{{company.email}}</p>
                        <p style="margin-bottom:7px;">{{company.phone}}</p>
                    </div>
                    <div class="col-12">
                        <table class="table table-bordered">
                            <tbody>
                            <tr>
                                <td class="bg-warning" style="text-transform: capitalize">First Year Revenue Goals</td>
                                <td>{{company.goal | money}}</td>
                            </tr>
                            <tr>
                                <td class="bg-warning" style="text-transform: initial">Year over year growth expectation</td>
                                <td>{{company.growth}}%</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="restInfo">
                <h3>Mission & Vision</h3>
                <p>{{questions.mission}}</p>
                <h3>Who are my target customer?</h3>
                <p :key="index" v-for="(target, index) in questions.targets">
                    {{target.name}}
                </p>
                <h3>Why will customer hire me?</h3>
                <p>{{questions.hire}}</p>
                <h3>How are you going to generate leads?</h3>
                <p>{{questions.generate_leads}}</p>
                <h3>How many leads from each source?</h3>
                <p>{{questions.leads_source}}</p>

            </div>
            <div class="not-mobile">
                <table class="table table-bordered table-striped table-sm" style="font-size: 100%">
                    <thead>
                    <tr>
                        <th colspan="7" class="text-center bg-primary text-white" style="font-size: 110%">Revenue drivers
                        </th>
                    </tr>
                    <tr style="font-size: 100%">
                        <th>Name</th>
                        <th>Monthly Leads</th>
                        <th>Annually Leads</th>
                        <th>Monthly Jobs</th>
                        <th>Annually Jobs</th>
                        <th>Monthly Revenue</th>
                        <th>Annually Revenue</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr :key="index" v-for="(type, index) in computedTypes">
                        <td>{{type.name}}</td>
                        <td>{{type.calculatedLeadsMonth}}</td>
                        <td>{{type.calculatedLeads}}</td>
                        <td>{{type.calculatedJobsMonth}}</td>
                        <td>{{type.calculatedJobs}}</td>
                        <td>{{type.formattedRevenueMonth}}</td>
                        <td>{{type.formattedRevenue}}</td>
                    </tr>
                    <tr class="bg-dark text-white">
                        <td>Total</td>
                        <td>{{totals.calculatedLeadsMonth}}</td>
                        <td>{{totals.calculatedLeads}}</td>
                        <td>{{totals.calculatedJobsMonth}}</td>
                        <td>{{totals.calculatedJobs}}</td>
                        <td>{{totals.calculatedRevenueMonth | money}}</td>
                        <td>{{totals.calculatedRevenue | money}}</td>
                    </tr>
                    </tbody>
                </table>

                <table class="table table-bordered table-striped table-sm" style="font-size: 100%;margin-top:40px">
                    <thead>
                    <tr>
                        <th colspan="7" class="text-center bg-primary text-white" style="font-size: 110%">Expenses drivers
                        </th>
                    </tr>
                    <tr style="font-size: 100%">
                        <th>Name</th>
                        <th>Monthly Expenses</th>
                        <th>Annually Expenses</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr :key="index" v-for="(expense, index) in computedExpenses">
                        <td>{{expense.name}}</td>
                        <td>{{expense.calculatedValue / 12  | money}}</td>
                        <td>{{expense.calculatedValue | money}}</td>
                    </tr>
                    <tr class="bg-dark text-white">
                        <td>Total</td>
                        <td>{{expensesTotals.calculatedValueMonth | money}}</td>
                        <td>{{expensesTotals.calculatedValue | money}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="mobile">
                <table class="table table-bordered table-striped table-sm tbl-reversed" style="font-size: 100%">
                    <thead>
                    <tr>
                        <th colspan="7" class="text-center bg-primary text-white" style="font-size: 110%">Revenue drivers
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <d  :key="index" v-for="(type, index) in computedTypes">
                        <tr>
                            <td>Name</td>
                            <td colspan="2">{{type.name}}</td>
                        </tr>
                        <tr>
                            <td>Monthly Leads</td>
                            <td>{{type.calculatedLeadsMonth}}</td>

                        </tr>
                        <tr>
                            <td>Annually Leads</td>
                            <td>{{type.calculatedLeads}}</td>

                        </tr>
                        <tr>
                            <td>Monthly Jobs</td>
                            <td>{{type.calculatedJobsMonth}}</td>

                        </tr>
                        <tr>
                            <td>Annually Jobs</td>
                            <td>{{type.calculatedJobs}}</td>

                        </tr>
                        <tr>
                            <td>Monthly Revenue</td>
                            <td>{{type.formattedRevenueMonth}}</td>

                        </tr>
                        <tr>
                            <td>Annually Revenue</td>
                            <td>{{type.formattedRevenue}}</td>

                        </tr>
                    </d>
                    </tbody>
                </table>

                <table class="table table-bordered table-striped table-sm" style="font-size: 100%;margin-top:40px">
                    <thead>
                    <tr>
                        <th colspan="7" class="text-center bg-primary text-white" style="font-size: 110%">Expenses drivers
                        </th>
                    </tr>
                    <tr style="font-size: 100%">
                        <th>Name</th>
                        <th>Monthly Expenses</th>
                        <th>Annually Expenses</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr :key="index" v-for="(expense, index) in computedExpenses">
                        <td>{{expense.name}}</td>
                        <td>{{expense.calculatedValue / 12  | money}}</td>
                        <td>{{expense.calculatedValue | money}}</td>
                    </tr>
                    <tr class="bg-dark text-white">
                        <td>Total</td>
                        <td>{{expensesTotals.calculatedValueMonth | money}}</td>
                        <td>{{expensesTotals.calculatedValue | money}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>



            <div class="row" style="margin-top:40px;" id="predictions-inputs">
                <div class="col-md-4">
                    <div class="form-group">
                        <h5>Revenue Goal $ <span class="text-danger">*</span></h5>
                        <money class="form-control" :class="{'alert-danger': future.goal <= 0}" v-model="future.goal"
                               v-bind="money"></money>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <h5>Profit goal% <span class="text-danger">*</span></h5>
                        <money class="form-control" :class="{'alert-danger': future.profit <= 0}" v-model="future.profit"
                               v-bind="percentage"></money>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <h5>year over year Growth % <span class="text-danger">*</span></h5>
                        <money class="form-control" :class="{'alert-danger': future.growth <= 0}" v-model="future.growth"
                               v-bind="percentage"></money>
                    </div>
                </div>
            </div>


            <div class="not-mobile">
                <table class="table table-bordered table-striped table-sm" style="font-size: 100%;margin-top:10px;">
                    <thead>
                    <tr>
                        <th colspan="7" class="text-center bg-primary text-white" style="font-size: 110%">Growth predictions
                        </th>
                    </tr>
                    <tr style="font-size: 100%">
                        <th></th>
                        <th>Year 1</th>
                        <th>Year 2</th>
                        <th>Year 3</th>
                        <th>Year 4</th>
                        <th>Year 5</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Revenue</td>
                        <td>{{year1.revenue | money}}</td>
                        <td>{{year2.revenue | money}}</td>
                        <td>{{year3.revenue | money}}</td>
                        <td>{{year4.revenue | money}}</td>
                        <td>{{year5.revenue | money}}</td>
                    </tr>
                    <tr>
                        <td>Expenses</td>
                        <td>{{year1.expenses | money}}</td>
                        <td>{{year2.expenses | money}}</td>
                        <td>{{year3.expenses | money}}</td>
                        <td>{{year4.expenses | money}}</td>
                        <td>{{year5.expenses | money}}</td>
                    </tr>
                    <tr>
                        <td>Profit</td>
                        <td>{{year1.profit | money}}</td>
                        <td>{{year2.profit | money}}</td>
                        <td>{{year3.profit | money}}</td>
                        <td>{{year4.profit | money}}</td>
                        <td>{{year5.profit | money}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="mobile">
                <table class="table table-bordered table-striped table-sm" style="font-size: 80%;margin-top:10px;">
                    <thead>
                    <tr>
                        <th colspan="7" class="text-center bg-primary text-white" style="font-size: 110%">Growth predictions
                        </th>
                    </tr>
                    <tr style="font-size: 100%">
                        <th>Year</th>
                        <th>Revenue</th>
                        <th>Expenses</th>
                        <th>Profit</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>{{year1.revenue | money}}</td>
                            <td>{{year1.expenses | money}}</td>
                            <td>{{year1.profit | money}}</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>{{year2.revenue | money}}</td>
                            <td>{{year2.expenses | money}}</td>
                            <td>{{year2.profit | money}}</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>{{year3.revenue | money}}</td>
                            <td>{{year3.expenses | money}}</td>
                            <td>{{year3.profit | money}}</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>{{year4.revenue | money}}</td>
                            <td>{{year4.expenses | money}}</td>
                            <td>{{year4.profit | money}}</td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>{{year5.revenue | money}}</td>
                            <td>{{year5.expenses | money}}</td>
                            <td>{{year5.profit | money}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
        <div id="result">
            <h1 class="text-center" style="text-transform: uppercase;font-size: 40px">business plan</h1>
            <div class="row headersh3">
                <div class="col-6">
                    <h2 style="margin-bottom:7px;text-transform: uppercase;font-size: 20px">{{company.name}}</h2>
                    <p style="margin-bottom:7px;text-transform: initial;font-weight:normal">{{company.address}}</p>
                    <p style="margin-bottom:7px;">{{company.email}}</p>
                    <p style="margin-bottom:7px;">{{company.phone}}</p>
                </div>
                <div class="col-6">
                    <table class="table table-bordered">
                        <tbody>
                        <tr>
                            <td class="bg-warning" style="text-transform: capitalize">First Year Revenue Goals</td>
                            <td>{{company.goal | money}}</td>
                        </tr>
                        <tr>
                            <td class="bg-warning" style="text-transform: initial">Year over year growth expectation</td>
                            <td>{{company.growth}}%</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="restInfo">
                <h3>Mission & Vision</h3>
                <p>{{questions.mission}}</p>
                <h3>Who are my target customer?</h3>
                <p :key="index" v-for="(target, index) in questions.targets">
                    {{target.name}}
                </p>
                <h3>Why will customer hire me?</h3>
                <p>{{questions.hire}}</p>
                <h3>How are you going to generate leads?</h3>
                <p>{{questions.generate_leads}}</p>
                <h3>How many leads from each source?</h3>
                <p>{{questions.leads_source}}</p>

            </div>

            <table class="table table-bordered table-striped table-sm" style="font-size: 100%">
                <thead>
                <tr>
                    <th colspan="7" class="text-center bg-primary text-white" style="font-size: 110%">Revenue drivers
                    </th>
                </tr>
                <tr style="font-size: 100%">
                    <th>Name</th>
                    <th>Monthly Leads</th>
                    <th>Annually Leads</th>
                    <th>Monthly Jobs</th>
                    <th>Annually Jobs</th>
                    <th>Monthly Revenue</th>
                    <th>Annually Revenue</th>
                </tr>
                </thead>
                <tbody>
                <tr :key="index" v-for="(type, index) in computedTypes">
                    <td>{{type.name}}</td>
                    <td>{{type.calculatedLeadsMonth}}</td>
                    <td>{{type.calculatedLeads}}</td>
                    <td>{{type.calculatedJobsMonth}}</td>
                    <td>{{type.calculatedJobs}}</td>
                    <td>{{type.formattedRevenueMonth}}</td>
                    <td>{{type.formattedRevenue}}</td>
                </tr>
                <tr class="bg-dark text-white">
                    <td>Total</td>
                    <td>{{totals.calculatedLeadsMonth}}</td>
                    <td>{{totals.calculatedLeads}}</td>
                    <td>{{totals.calculatedJobsMonth}}</td>
                    <td>{{totals.calculatedJobs}}</td>
                    <td>{{totals.calculatedRevenueMonth | money}}</td>
                    <td>{{totals.calculatedRevenue | money}}</td>
                </tr>
                </tbody>
            </table>

            <table class="table table-bordered table-striped table-sm" style="font-size: 100%;margin-top:40px">
                <thead>
                <tr>
                    <th colspan="7" class="text-center bg-primary text-white" style="font-size: 110%">Expenses drivers
                    </th>
                </tr>
                <tr style="font-size: 100%">
                    <th>Name</th>
                    <th>Monthly Expenses</th>
                    <th>Annually Expenses</th>
                </tr>
                </thead>
                <tbody>
                <tr :key="index" v-for="(expense, index) in computedExpenses">
                    <td>{{expense.name}}</td>
                    <td>{{expense.calculatedValue / 12  | money}}</td>
                    <td>{{expense.calculatedValue | money}}</td>
                </tr>
                <tr class="bg-dark text-white">
                    <td>Total</td>
                    <td>{{expensesTotals.calculatedValueMonth | money}}</td>
                    <td>{{expensesTotals.calculatedValue | money}}</td>
                </tr>
                </tbody>
            </table>


            <div class="row" style="margin-top:40px;" id="predictions-inputs">
                <div class="col-md-4">
                    <div class="form-group">
                        <h5>Revenue Goal $ <span class="text-danger">*</span></h5>
                        <money class="form-control" :class="{'alert-danger': future.goal <= 0}" v-model="future.goal"
                               v-bind="money"></money>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <h5>Profit goal% <span class="text-danger">*</span></h5>
                        <money class="form-control" :class="{'alert-danger': future.profit <= 0}" v-model="future.profit"
                               v-bind="percentage"></money>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <h5>year over year Growth % <span class="text-danger">*</span></h5>
                        <money class="form-control" :class="{'alert-danger': future.growth <= 0}" v-model="future.growth"
                               v-bind="percentage"></money>
                    </div>
                </div>
            </div>

            <table class="table table-bordered table-striped table-sm" style="font-size: 100%;margin-top:10px;">
                <thead>
                <tr>
                    <th colspan="7" class="text-center bg-primary text-white" style="font-size: 110%">Growth predictions
                    </th>
                </tr>
                <tr style="font-size: 100%">
                    <th></th>
                    <th>Year 1</th>
                    <th>Year 2</th>
                    <th>Year 3</th>
                    <th>Year 4</th>
                    <th>Year 5</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Revenue</td>
                    <td>{{year1.revenue | money}}</td>
                    <td>{{year2.revenue | money}}</td>
                    <td>{{year3.revenue | money}}</td>
                    <td>{{year4.revenue | money}}</td>
                    <td>{{year5.revenue | money}}</td>
                </tr>
                <tr>
                    <td>Expenses</td>
                    <td>{{year1.expenses | money}}</td>
                    <td>{{year2.expenses | money}}</td>
                    <td>{{year3.expenses | money}}</td>
                    <td>{{year4.expenses | money}}</td>
                    <td>{{year5.expenses | money}}</td>
                </tr>
                <tr>
                    <td>Profit</td>
                    <td>{{year1.profit | money}}</td>
                    <td>{{year2.profit | money}}</td>
                    <td>{{year3.profit | money}}</td>
                    <td>{{year4.profit | money}}</td>
                    <td>{{year5.profit | money}}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <vue-html2pdf
                :show-layout="false"
                :float-layout="false"
                :enable-download="true"
                :preview-modal="false"
                :paginate-elements-by-height="1400"
                filename="hee hee"
                :pdf-quality="3"
                :manual-pagination="false"
                pdf-format="a4"
                @hasDownloaded="sendEmail"
                ref="html2Pdf"
        >
            <section slot="pdf-content">
                <div id="pdf">
                    <h1 class="text-center" style="text-transform: uppercase;font-size: 40px">business plan</h1>
                    <div class="row headersh3">
                        <div class="col-6">
                            <h2 style="margin-bottom:7px;text-transform: uppercase;font-size: 20px">{{company.name}}</h2>
                            <p style="margin-bottom:7px;text-transform: initial;font-weight:normal">{{company.address}}</p>
                            <p style="margin-bottom:7px;">{{company.email}}</p>
                            <p style="margin-bottom:7px;">{{company.phone}}</p>
                        </div>
                        <div class="col-6">
                            <table class="table table-bordered">
                                <tbody>
                                <tr>
                                    <td class="bg-warning" style="text-transform: capitalize">First Year Revenue Goals</td>
                                    <td>{{company.goal | money}}</td>
                                </tr>
                                <tr>
                                    <td class="bg-warning" style="text-transform: initial">Year over year growth expectation</td>
                                    <td>{{company.growth}}%</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="restInfo">
                        <h5>Mission & Vision</h5>
                        <p>{{questions.mission}}</p>
                        <h5>Who are my target customer?</h5>
                        <p :key="index" v-for="(target, index) in questions.targets">
                            {{target.name}}
                        </p>
                        <h5>Why will customer hire me?</h5>
                        <p>{{questions.hire}}</p>
                        <h5>How are you going to generate leads?</h5>
                        <p>{{questions.generate_leads}}</p>
                        <h5>How many leads from each source?</h5>
                        <p>{{questions.leads_source}}</p>

                    </div>
                    <div class="html2pdf__page-break"/>
                    <table class="table table-bordered table-striped table-sm" style="font-size: 100%;margin-top:40px;">
                        <thead>
                        <tr>
                            <th colspan="7" class="text-center bg-primary text-white" style="font-size: 110%">Revenue drivers
                            </th>
                        </tr>
                        <tr style="font-size: 100%">
                            <th>Name</th>
                            <th>Monthly Leads</th>
                            <th>Annually Leads</th>
                            <th>Monthly Jobs</th>
                            <th>Annually Jobs</th>
                            <th>Monthly Revenue</th>
                            <th>Annually Revenue</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr :key="index" v-for="(type, index) in computedTypes">
                            <td>{{type.name}}</td>
                            <td>{{type.calculatedLeadsMonth}}</td>
                            <td>{{type.calculatedLeads}}</td>
                            <td>{{type.calculatedJobsMonth}}</td>
                            <td>{{type.calculatedJobs}}</td>
                            <td>{{type.formattedRevenueMonth}}</td>
                            <td>{{type.formattedRevenue}}</td>
                        </tr>
                        <tr class="bg-dark text-white">
                            <td>Total</td>
                            <td>{{totals.calculatedLeadsMonth}}</td>
                            <td>{{totals.calculatedLeads}}</td>
                            <td>{{totals.calculatedJobsMonth}}</td>
                            <td>{{totals.calculatedJobs}}</td>
                            <td>{{totals.calculatedRevenueMonth | money}}</td>
                            <td>{{totals.calculatedRevenue | money}}</td>
                        </tr>
                        </tbody>
                    </table>

                    <table class="table table-bordered table-striped table-sm" style="font-size: 100%;margin-top:40px">
                        <thead>
                        <tr>
                            <th colspan="7" class="text-center bg-primary text-white" style="font-size: 110%">Expenses drivers
                            </th>
                        </tr>
                        <tr style="font-size: 100%">
                            <th>Name</th>
                            <th>Monthly Expenses</th>
                            <th>Annually Expenses</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr :key="index" v-for="(expense, index) in computedExpenses">
                            <td>{{expense.name}}</td>
                            <td>{{expense.calculatedValue / 12  | money}}</td>
                            <td>{{expense.calculatedValue | money}}</td>
                        </tr>
                        <tr class="bg-dark text-white">
                            <td>Total</td>
                            <td>{{expensesTotals.calculatedValueMonth | money}}</td>
                            <td>{{expensesTotals.calculatedValue | money}}</td>
                        </tr>
                        </tbody>
                    </table>

                    <div class="row" style="margin-top:40px;" id="predictions-inputs">
                        <div class="col-md-4">
                            <div class="form-group">
                                <h5>Revenue Goal $ <span class="text-danger">*</span></h5>
                                <money class="form-control" :class="{'alert-danger': future.goal <= 0}" v-model="future.goal"
                                       v-bind="money"></money>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <h5>Profit goal% <span class="text-danger">*</span></h5>
                                <money class="form-control" :class="{'alert-danger': future.profit <= 0}" v-model="future.profit"
                                       v-bind="percentage"></money>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <h5>year over year Growth % <span class="text-danger">*</span></h5>
                                <money class="form-control" :class="{'alert-danger': future.growth <= 0}" v-model="future.growth"
                                       v-bind="percentage"></money>
                            </div>
                        </div>
                    </div>

                    <table class="table table-bordered table-striped table-sm" style="font-size: 100%;margin-top:10px;">
                        <thead>
                        <tr>
                            <th colspan="7" class="text-center bg-primary text-white" style="font-size: 110%">Growth predictions
                            </th>
                        </tr>
                        <tr style="font-size: 100%">
                            <th></th>
                            <th>Year 1</th>
                            <th>Year 2</th>
                            <th>Year 3</th>
                            <th>Year 4</th>
                            <th>Year 5</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>Revenue</td>
                            <td>{{year1.revenue | money}}</td>
                            <td>{{year2.revenue | money}}</td>
                            <td>{{year3.revenue | money}}</td>
                            <td>{{year4.revenue | money}}</td>
                            <td>{{year5.revenue | money}}</td>
                        </tr>
                        <tr>
                            <td>Expenses</td>
                            <td>{{year1.expenses | money}}</td>
                            <td>{{year2.expenses | money}}</td>
                            <td>{{year3.expenses | money}}</td>
                            <td>{{year4.expenses | money}}</td>
                            <td>{{year5.expenses | money}}</td>
                        </tr>
                        <tr>
                            <td>Profit</td>
                            <td>{{year1.profit | money}}</td>
                            <td>{{year2.profit | money}}</td>
                            <td>{{year3.profit | money}}</td>
                            <td>{{year4.profit | money}}</td>
                            <td>{{year5.profit | money}}</td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="text-center" style="width:100%;margin-top:30px;">
                        <a class="text-center" href="http://getoutofthetruck.life">Getoutofthetruck.life (c) 2020</a>
                    </div>

                </div>

            </section>
        </vue-html2pdf>
        <div class="step-btns d-print-none">
<!--            <div class="">-->
<!--                <button class="btn btn-previous" v-if="step > 1" type="button" @click="$refs.stepper.previous()">Previous-->
<!--                </button>-->
<!--            </div>-->
            <div class="row">
                <div class="col-4">
                    <button class="btn btn-previous" v-if="step > 1" type="button" @click="$refs.stepper.previous()">Previous
                    </button>
                </div>
                <div class="col-8" v-if="step < 5"><button class="btn btn-next" type="button" @click="$refs.stepper.next()">Next</button></div>
                <div class="col-8" v-if="step === 5"><button class="btn btn-finish" type="button" style="background: forestgreen" @click="generateReport()">Download</button></div>
<!--                <button class="btn btn-next" v-if="step < 5" type="button" @click="$refs.stepper.next()">Next</button>-->
<!--                <button class="btn btn-finish" v-if="step === 5" type="button" style="background: forestgreen" @click="generateReport()">Download</button>-->
<!--                <button class="btn btn-finish" style="margin-right:30px;background:rebeccapurple" v-if="step === 5" type="button" @click="window.print()">Print</button>-->
            </div>
        </div>
    </div>
</template>

<script>
  import {VStepper} from 'vue-stepper-component'
  import {Money} from 'v-money'
  import VueHtml2pdf from 'vue-html2pdf'
  import axios from 'axios'

  export default {
    name: 'App',
    components: {
      VStepper,
      Money,
      VueHtml2pdf,
    },
    data: () => ({
      window: window,
      steps: 6,
      step: undefined,
      stepsBackgrounds: [
        '1.jpg'
      ],
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        precision: 0,
        masked: false
      },
      percentage: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '%',
        precision: 0,
        masked: false
      },
      questions: {
        mission: '',
        targets: [{
          name: ''
        }],
        generate_leads: '',
        leads_source: '',
        hire: ''
      },
      future: {
        goal: undefined,
        profit: undefined,
        growth: undefined,
        expenses: undefined,
        revenue: undefined,
      },
      company: {
        name: undefined,
        growth: undefined,
        email: undefined,
        phone: undefined,
        address: undefined,
        goal: undefined,
        expenses: undefined,
      },
      revenue_type: '%',
      expense_type: '%',
      types: [{
        name: '',
        conversion: 0,
        revenue: 0,
        revenue_type: '%',
        amount: 0,
      }],
      type: {
        name: '',
        conversion: 0,
        revenue: 0,
        revenue_type: '%',
        amount: 0,
      },
      expenses: [{
        name: undefined,
        amount: undefined,
        type: '%'
      }],
      expense: {
        name: undefined,
        amount: undefined,
        type: '%'
      },
      result: {},
    }),
    methods: {
      addType() {
        this.types.push(Object.assign({}, this.type))
      },
      deleteType(index) {
        this.types.splice(index, 1)
      },
      addExpense() {
        this.expenses.push(Object.assign({}, this.expense))
      },
      deleteExpense(index) {
        this.expenses.splice(index, 1)
      },
      generateReport () {
        document.getElementById('pdf').style.display = "block";
        this.$refs.html2Pdf.generatePdf();
        setTimeout(() => {
          document.getElementById('pdf').style.display = "none";
        }, 3000)

      },
      sendEmail(e){
        let reader = new FileReader();
        reader.readAsDataURL(e);
        reader.onloadend = function() {
          let base64data = reader.result;
          console.log(base64data);
          axios.post('https://911.gazingle.com/get_out_of_the_truck', {
            file: base64data,
          })
            .then(() => {
            })
            .catch(() => {

            });
        }
        //let file = new File([e], "name");
        // console.log(file);
        // console.log(this.blobToFile(e, "my-image.pdf"))
        // console.log(e)
      },
      blobToFile(theBlob, fileName){
        //A Blob() is almost a File() - it's just missing the two properties below which we will add
        theBlob.lastModifiedDate = new Date();
        theBlob.name = fileName;
        return theBlob;
      },
    },
    filters: {
      money(val) {
        let formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        return formatter.format(val);
      }
    },
    computed: {
      computedFuture(){
        return {
          goal: this.future.goal,
          profit: this.future.profit,
          growth: this.future.growth,
          expenses: this.future.goal - parseInt(this.future.goal * this.future.profit / 100),
          dollarProfit: this.future.goal * this.future.profit / 100,
        }
      },
      year1(){
        return {
          revenue: this.computedFuture.goal,
          profit: this.computedFuture.dollarProfit,
          expenses: this.computedFuture.expenses,
        }
      },
      year2(){
        return {
          revenue: this.year1.revenue + (this.year1.revenue * this.computedFuture.growth / 100),
          profit: this.year1.profit + (this.year1.profit * this.computedFuture.growth / 100),
          expenses: this.year1.expenses + (this.year1.expenses * this.computedFuture.growth / 100),
        }
      },
      year3(){
        return {
          revenue: this.year2.revenue + (this.year2.revenue * this.computedFuture.growth / 100),
          profit: this.year2.profit + (this.year2.profit * this.computedFuture.growth / 100),
          expenses: this.year2.expenses + (this.year2.expenses * this.computedFuture.growth / 100),
        }
      },
      year4(){
        return {
          revenue: this.year3.revenue + (this.year3.revenue * this.computedFuture.growth / 100),
          profit: this.year3.profit + (this.year3.profit * this.computedFuture.growth / 100),
          expenses: this.year3.expenses + (this.year3.expenses * this.computedFuture.growth / 100),
        }
      },
      year5(){
        return {
          revenue: this.year4.revenue + (this.year4.revenue * this.computedFuture.growth / 100),
          profit: this.year4.profit + (this.year4.profit * this.computedFuture.growth / 100),
          expenses: this.year4.expenses + (this.year4.expenses * this.computedFuture.growth / 100),
        }
      },
      calculatedFuture(){
        let result = {
          year1expenses: this.future.expenses,
          year1profit: this.future.profit,
          year1revenue: this.future.goal,
        };
        return result;
      },
      totals() {
        let result = {
          calculatedLeads: 0,
          calculatedLeadsMonth: 0,
          calculatedJobs: 0,
          calculatedJobsMonth: 0,
          calculatedRevenue: 0,
          calculatedRevenueMonth: 0,
        };
        this.computedTypes.forEach(item => {
          result.calculatedLeads = result.calculatedLeads + item.calculatedLeads;
          result.calculatedLeadsMonth = result.calculatedLeadsMonth + item.calculatedLeadsMonth;
          result.calculatedJobs = result.calculatedJobs + item.calculatedJobs;
          result.calculatedJobsMonth = result.calculatedJobsMonth + item.calculatedJobsMonth;
          result.calculatedRevenue = result.calculatedRevenue + item.calculatedRevenue;
          result.calculatedRevenueMonth = result.calculatedRevenueMonth + item.calculatedRevenueMonth;
        });
        return result;
      },
      expensesTotals() {
        let result = {
          calculatedValue: 0,
          calculatedValueMonth: 0,
        };
        this.computedExpenses.forEach(item => {
          result.calculatedValue = result.calculatedValue + item.calculatedValue;
          result.calculatedValueMonth = result.calculatedValueMonth + item.calculatedValueMonth;
        });
        return result;
      },
      computedTypes() {
        return this.types.map((item) => {
          let cg = this.company.goal ? this.company.goal : 0;
          let rev = item.revenue ? item.revenue : 0;
          let formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          if (this.revenue_type === '%') {
            item.formattedRevenue = formatter.format(cg * rev / 100)
            item.calculatedRevenue = parseFloat(cg * rev / 100)
          } else {
            item.calculatedRevenue = rev;
          }
          if (this.revenue_type === '$') {
            item.calculatedPercantage = parseFloat(rev / cg * 100).toFixed(2)
          }
          item.calculatedLeads = parseInt(item.calculatedRevenue / item.amount / item.conversion * 100);
          item.calculatedLeadsMonth = parseInt(item.calculatedLeads / 12);
          item.calculatedJobs = parseInt(item.calculatedRevenue / item.amount);
          item.calculatedJobsMonth = parseInt(item.calculatedJobs / 12);
          item.calculatedRevenueMonth = parseFloat(item.calculatedRevenue / 12);
          item.formattedRevenueMonth = formatter.format(item.calculatedRevenue / 12);
          return item;
        })
      },
      computedExpenses() {
        return this.expenses.map((item) => {
          let cg = this.company.expenses ? this.company.expenses : 0;
          let rev = item.amount ? item.amount : 0;
          let formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
          if (this.expense_type === '%') {
            item.formattedValue = formatter.format(cg * rev / 100)
            item.calculatedValue = parseFloat(cg * rev / 100)
          } else {
            item.calculatedValue = rev;
          }
          if (this.expense_type === '$') {
            item.calculatedPercantage = parseFloat(rev / cg * 100).toFixed(2)
          }
          item.calculatedValueMonth = item.calculatedValue / 12
          return item;
        })
      },
      expensesSum(){
        return this.computedExpenses.reduce((accumulator, current) => accumulator + current.calculatedValue, 0);
      },
    },
    watch: {
      computedTypes: {
        handler: () => {

        },
        deep: true
      },
      computedExpenses: {
        handler: () => {

        },
        deep: true
      },
      company: {
        handler(o){
          this.future.goal = o.goal;
          this.future.growth = o.growth;
          this.future.profit = parseInt(100 - this.company.expenses / this.company.goal * 100)
        },
        deep: true
      },
      expensesTotals: {
        handler(o){
          this.future.expenses = o.calculatedValue
        },
        deep: true
      },
      totals: {
        handler(o){
          this.future.revenue = o.calculatedRevenue
        },
        deep: true
      },
    }
  }
</script>
<style scoped>
    .mobile{
        display:none
    }
    #result{
        display:none
    }
    @media print {
        body {-webkit-print-color-adjust: exact;}
        /*html, body {*/
        /*    width: 210mm;*/
        /*    height: 297mm;*/
        /*}*/
        #result{
            display:block
        }
        #app{
            margin:0!important;
            padding:0!important;
            height: auto;
            overflow-y:scroll
        }
        .card-box{
            width: 100vw!important;
            min-width: 100vw!important;
            max-width: 100vw!important;
            height:auto!important;
            margin: 0;
            padding: 0px;
            border: 0;
            border-radius: 0;
            -moz-border-radius: 0;
            margin-bottom: 0;
            background-color: rgba(255,255,255,1);
            box-shadow: none;
        }
        .d-print-none {
            display: none!important;
        }
        .card-box{
            display:none;
        }
        #result{
            padding:40px;
            width:100%;
            background:white
        }
        #app{
            width: 100vw;
            min-height: initial!important;
            max-height: none!important;
            height: auto!important;
            overflow-y: auto!important;
            padding-top: 100px;
            padding-bottom: 100px;
        }
        table{
            page-break-inside: avoid;
        }
        #predictions-inputs input{
            border:none;
            padding:0;
            margin-left:-15px;
            font-weight:bold
        }
        #predictions-inputs .text-danger{
            display:none
        }
        h3{
            font-size:115%;
            font-weight:bold;
            text-transform:uppercase;
        }
        .restInfo{
            margin-top:40px;
        }
        .headersh3{
            margin-top:30px;
        }
        p{
            font-size:125%
        }
        .bg-dark {
            font-size: 110%;
            color:black!important;
            font-weight:bold;
            background: black!important;
            -webkit-print-color-adjust: exact;
            background-color: #f5f5f5 !important;
        }
        /* ... the rest of the rules ... */
    }
    #preview .bg-warning{
        background:#f7a619;
        color:white
    }
    #app .stepper>div:nth-child(5){
        width:23%!important
    }
    #preview .table-bordered td, .table-bordered th{
        border-color:black;
        padding:7px
    }
    #preview .headersh3{
        margin-bottom:30px;
        clear:both
    }
    .restInfo h3{
        text-decoration:underline;
    }
    .add-new {
        margin-top: 32px
    }

    .minus-btn {
        width: 100%
    }

    .plus-btn {
        width: 100%
    }

    .type-row {
        margin-bottom: 10px;
    }

    .type-row label {
        color: gray;
        font-size: 90%;
        font-style: italic;
    }

    .step-btns {
        margin-top: 15px;
        /*padding-right:45px*/
    }

    .bg-gray {
        background-color: gray;
        color: white
    }

    #preview .table {
        width: 100%
    }
    #app #predictions-inputs h5{
        font-size:85%!important;
        text-transform: uppercase;
        font-weight:bold
    }
    #app #preview{
        padding: 60px;
    }
    #app #preview h1{
        text-transform: uppercase;
        font-weight:bold;
        text-align: center;
        font-size:150%
    }
    #app #preview h3{
        text-transform: uppercase;
        font-size: 90%;
        background: #fff;
        color: #000;
        font-weight: 700
    }
    #app{
        width: 100vw;
        min-height: 100vh;
        max-height: 100vh;
        height: 100vh;
        overflow-y: auto;
        padding-top: 100px;
        padding-bottom: 100px
    }
    #app h1{
        font-size:42px!important;
    }
    #app h5{
        font-size:100%!important;
        text-transform:uppercase!important;
        font-family: 'Oswald', sans-serif;
    }
    #app .row>.col-md-10>strong{
        font-size:100%!important;
        text-transform:uppercase!important;
        font-family: 'Oswald', sans-serif;
        font-weight:bold;
        color:black;
    }
    #app form label{
        font-weight: bold;
    }
    #app .stepper{
        width: 100vw;
        position: absolute;
        margin-top:-100px;
        background:#ffffff;
        border-bottom:10px solid #5bc0de;
        padding:20px 80px;
        height:80px;
        z-index: 99999;
    }
    #app .stepper>div {
        float: left;
        width: 13%!important;
        text-align: center;
    }
    #app .stepper > div > button{
        text-transform: uppercase;
        padding-top:3px!important;
        height:30px;
        border-radius:0
    }
    #app .stepper > div > button.active{
        border:1px solid black
    }
    .m-t-20{
        margin-top:20px;
    }
    .card-box{
        width: calc(100vw - 30%);
        min-width:600px;
        max-width:1160px;
        margin: 0 auto;
        padding: 20px;
        border: 1px solid rgba(54, 64, 74, 0.05);
        -webkit-border-radius: 5px;
        border-radius: 5px;
        -moz-border-radius: 5px;
        background-clip: padding-box;
        margin-bottom: 20px;
        background-color: rgba(255,255,255,1);
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3)!important;
    }
    .step-btns{
        position: fixed;
        bottom:0;
        height:100px;
        width:100vw;
        padding:30px 80px;
        background:#ffffff;
        border-top:10px solid #5bc0de;
    }
    .step-btns .btn{
        background:#FFAB00;
        color:white;
        border-radius:0;
        width:110px;
        box-shadow: none!important;
    }
    .step-btns .btn-next{
        float:right
    }
    .step-btns .btn-finish{
        float:right
    }
    .step-btns .btn-previous{
        float:left
    }

    #app .btn-sm.btn-danger{
        background: #dc3545;
        border-color:#dc3545;
        box-shadow:none;
        width:40px;
        height: 37px;
    }
    #app .table .btn-sm.btn-danger{
        width: 30px;
        height: 30px;
        padding-top: 0px;
        margin-top: 4px;
    }
    #app .btn-sm.btn-success{
        background: #5bc0de;
        border-color:#5bc0de;
        box-shadow:none;
        width:40px;
        height: 37px;
    }
    #app .btn-outline-success{
        background: #5bc0de;
        border-color:#5bc0de;
        color:#fff;
        padding-top:3px;
        box-shadow:none;
        height: 30px;
        border-radius:0;
        text-transform: uppercase;
    }
    #app .text-success{
        color:#5bc0de!important;
    }
    #app .table th{
        background:white;
        color:black;
        border-color:black;
        font-size:80%;
        text-transform: uppercase;
    }
    #app .form-group strong{
        font-size:14px;
    }
    #app .bg-primary{
        background:#b0e7f7!important;
        color:black!important;
    }
    .step-1{
        background-image: url("assets/1.jpg");
        background-position: left;
        background-size: cover;
        background-repeat: no-repeat;
    }
    .step-2{
        background-image: url("assets/2.jpg");
        background-position: left;
        background-size: cover;
        background-repeat: no-repeat;
    }
    .step-3{
        background-image: url("assets/3.jpg");
        background-position: left;
        background-size: cover;
        background-repeat: no-repeat;
    }
    .step-4{
        background-image: url("assets/4.jpg");
        background-position: left;
        background-size: cover;
        background-repeat: no-repeat;
    }
    .step-5{
        background-image: url("assets/5.jpg");
        background-position: left;
        background-size: cover;
        background-repeat: no-repeat;
    }






    #app .form-control{
        height:35px!important;
        box-shadow:none!important;
        padding-left: 15px!important;
    }
    #app .step-btns .btn-finish, #app .step-btns .btn-next, #app .step-btns .btn-previous{
        height: 40px;
        line-height: 10px;
    }
    #app h1{
        font-size:42px!important;
    }
    #app h5{
        font-size:100%!important;
        text-transform:uppercase!important;
        font-family: 'Oswald', sans-serif;
    }
    #app .row>.col-md-10>strong{
        font-size:100%!important;
        text-transform:uppercase!important;
        font-family: 'Oswald', sans-serif;
        font-weight:bold;
        color:black;
    }
    #app .form-group>strong{
        font-size:100%!important;
        text-transform:uppercase!important;
        font-family: 'Oswald', sans-serif;
        font-weight:bold;
        color:black;
    }
    #app .form-group>label{
        font-size:100%!important;
        text-transform:uppercase!important;
        font-family: 'Oswald', sans-serif;
        font-weight:bold;
        color:black;
    }
    #app textarea.form-control{
        height:auto!important;
        padding:10px;
    }
    #app #preview{
        color:black
    }
    #app #preview h3 {
        text-transform: uppercase;
        font-size: 90%;
        background: none!important;
        color: #000;
        font-weight: 700;
        margin-bottom: 30px;
    }
    #app #preview h3 {
        text-transform: uppercase;
        font-size: 90%;
        background: #fff!important;
        color: #000;
        font-weight: 700
    }
    #app button{
        outline: none;
    }
    #app .card-box{
        min-height: 670px;
    }
    #app .stepper>div>button{
        background: none;
        color:black
    }
    #app #preview th{
        font-size:85%!important;
    }
    #app .table-warning strong{
        margin-left:5px;
    }
    #app .step-btns{
        position: fixed;
        bottom: 0;
        height: 76px!important;
        width: 100vw!important;
        padding: 15px 80px!important;;
        background: #ffffff!important;;
        border-top: 10px solid #5bc0de!important;
    }
    #app .stepper {
        width: 100vw;
        position: absolute;
        margin-top: -100px!important;
        background: #fff;
        border-bottom: 10px solid #5bc0de!important;
        padding: 10px 80px!important;
        height: 60px!important;
        z-index: 99999!important;
        padding-left: 25%!important;
    }
    #business_plan > .btn-danger {
        width: 40px;
        height: 40px;
        margin-top: -5px;
        padding: 0;
        font-size: 16px;
    }
    #app .card-box{
        background: rgba(255,255,255,0.9);
    }
    #preview{
        background:#fff!important;
    }
    #pdf{
        margin-left:30px;
        margin-top:30px;
        margin-bottom:20px;
        display:none;
        width:740px!important;
        font-size:13px;
    }
    #pdf h5{
        font-size:15px!important;
        text-decoration:underline;
        text-transform: uppercase;
    }
    #pdf #predictions-inputs h5{
        text-decoration:none;
        text-transform: none;
    }
    #pdf .bg-primary{
        background:rgb(176, 231, 247)!important;
        color:black!important;
        text-transform: uppercase;
    }
    #pdf .headersh3{
        margin-top:40px;
        margin-bottom:30px;
    }
    @media print {
        .d-print-none {
            display: none!important;
        }
    }

    @media only screen and (max-width: 600px) {
        #app .card-box{
            width:100%;
            min-width:100px;
        }
        #app .stepper{
            width: 100vw;
            position: absolute;
            margin-top: -100px!important;
            background: #fff;
            border-bottom: 10px solid #5bc0de!important;
            padding: 0px 0px!important;
            height: 60px!important;
            z-index: 99999!important;
            padding-left: 10px!important;
        }
        #app .stepper>div{
            float: left;
            width: 17%!important;
            text-align: center;
        }
        #app .stepper > div > button{
            text-transform: uppercase;
            padding-top: 3px!important;
            height: 50px;
            border-radius: 0;
        }
        #app h1{
            font-size: 30px!important;
        }
        #app .form-group>label{
            font-size:80%!important
        }
        #app .step-btns{
            padding: 15px 5px!important;
        }
        #app .form-group>strong {
            font-size: 80%!important;
            text-transform: uppercase!important;
            font-family: 'Oswald', sans-serif;
            font-weight: bold;
            color: black;
        }
        #app .row>.col-md-10>strong{
            font-size:80%!important
        }
        #app #preview{
            padding: 10px
        }
        .job-typer{
            border:1px solid gray;
            border-radius:5px;
            margin-bottom:10px;
        }
        .job-typer label{
            font-size:80%
        }
        h2{
            font-size:30px;
        }
        .mobile .headersh3 .col-6{
            flex: 0 0 100%;
            max-width: 100%;
        }
        .tbl-reversed td{
            width: calc(50vw - 14px);
            min-width: calc(50vw - 14px);
        }
        .tbl-reversed d{
            border-bottom: 7px solid black;
        }
        .mobile{
            display:block
        }
        .not-mobile{
            display:none
        }
    }
</style>
